import classNames from "classnames";

import Image from "components/Image";

enum BylineSizes {
  "small" = 54,
  "large" = 90,
}

type Props = {
  alt: string;
  className?: string;
  size?: keyof typeof BylineSizes;
  src: string;
};

const BylineImage: React.FC<Props> = ({
  size = "small",
  alt,
  src,
  className,
}) => {
  return (
    <div
      style={{ height: BylineSizes[size], width: BylineSizes[size] }}
      className={classNames(
        className,
        "rounded-full border border-light-grey overflow-hidden mr-md relative"
      )}
    >
      <Image
        alt={alt}
        src={src}
        sizes={[BylineSizes[size]]}
        background
        backgroundFit="cover"
        backgroundPosition="center"
      />
    </div>
  );
};

export default BylineImage;
